export default class KnxIds {

    ids: any = {}

    constructor(public complexId: string | undefined) {
        if (!complexId) return;

        const ss = complexId.split("_");
        for (const s of ss) {
            const parts = s.split("-");
            //
            // für "O-2-27" müssen wir die 27 nehmen
            //
            this.ids[parts[0]] = parts[parts.length - 1];
        }
    }

    getId(type: string): string | undefined {
        return this.ids[type];
    }
}
